import { FASTElement, HostBehavior, HostController, Observable } from "@microsoft/fast-element";

export class CSSClassBehavior implements HostBehavior<FASTElement> {
    constructor(
        protected propertyName: string,
        protected cssClassNameOn: string,
        protected cssClassNameOff: string = ''
    ) { }

    /**
     * Binds the behavior to the element.
     * @param elementInstance - The element for which the property is applied.
     */
    public addedCallback(controller: HostController) {
        Observable.getNotifier(controller.source).subscribe(this, this.propertyName);
        this.handleChange(controller.source, this.propertyName);
    }

    /**
     * Unbinds the behavior from the element.
     * @param source - The element for which the behavior is unbinding.
     */
    public removedCallback(controller: HostController) {
        Observable.getNotifier(controller.source).unsubscribe(this, this.propertyName);
        controller.source.classList.remove(this.cssClassNameOn);
        controller.source.classList.remove(this.cssClassNameOff);
    }

    /**
     * Change event for the provided element.
     * @param source - the element for which to toggle the class.
     * @param key - the key to lookup to know if the element already has the class
     * @internal
     */
    public handleChange(source: FASTElement, key: string) {
        if (this.cssClassNameOn)
            source.classList.toggle(this.cssClassNameOn, source[key] || false);

        if (this.cssClassNameOff)
            source.classList.toggle(this.cssClassNameOff, !source[key]);
    }
}
